import React from 'react';
import { Outlet } from 'react-router-dom';

import ToolbarNavigation from 'app/components/ToolbarNavigation/ToolbarNavigation';
import MProgressBar from 'app/ui/MProgressBar/MProgressBar';

import classes from './Layout.module.scss';
import MFooter from 'app/ui/MFooter/MFooter';
import moment from 'moment';

interface Props {}

const LayoutView: React.FC<Props> = () => {
  return (
    <React.Fragment>
      <MProgressBar></MProgressBar>
      <ToolbarNavigation></ToolbarNavigation>
      <main className={classes['content']}>
        <Outlet></Outlet>
      </main>
      <MFooter title={`© Moovex ${moment().year()} All rights reserved`}></MFooter>
    </React.Fragment>
  );
};

LayoutView.displayName = 'LayoutView';
LayoutView.defaultProps = {};

export default LayoutView;
